import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { UserSetting } from '@models/masters/user.model';
import { ResponseResult } from '@models/authentication/login';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpBaseService } from '@service/http-base.service';
import { AuthTokenHelper } from '@helpers/auth-token-helper';
import { BeyondEMRHelper } from '@helpers/beyondemr-helper';
import { AuthService } from '@service/auth.sevice';


@Component({
    selector: 'patient-reset-password',
    templateUrl: './patient-reset-password.component.html',
    styleUrls: ['./patient-reset-password.component.css']
})

export class PatientResetPassword implements OnInit {
    loginForm: FormGroup;
    submitted = false;
    public apiURL = null;
    returnUrl: string;
    showValidation: boolean = false;
    resetCode: any;
    userName: string;
    passCode: string;
    user: string;
    domain: string;
    code: string;
    hide: boolean = true;
    confirmHide: boolean = true;
    userCredential: string;

    constructor(
        private formBuilder: FormBuilder,
        private spinner: NgxSpinnerService,
        private route: ActivatedRoute,
        private router: Router,
        private httpService: HttpBaseService,
        private authHelper?: AuthTokenHelper,
        private helper?: BeyondEMRHelper,
        private http?: HttpClient,
        private authService?: AuthService,
    ) { }

    ngOnInit() {
        this.httpService.getAPIURL().subscribe(url => {
            this.apiURL = `${url.API_URL}`;
        });
        this.getUserData();
        this.spinner.hide()
        this.loginForm = this.createForm('', '');
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    formControl = new FormControl('', [
        Validators.required
    ]);

    createForm(user, passcode): FormGroup {
        loginForm: FormGroup;
        return this.formBuilder.group({
            name: user,
            password: '',
            confirmPassword: '',
            code: passcode
        });
    }

    validate(): boolean {
        let result = true;
        if (this.loginForm.getRawValue().password != this.loginForm.getRawValue().confirmPassword) {
            this.loginForm.controls['confirmPassword'].setErrors({ 'incorrect': true });
            result = false;
        }
        return result;
    }

    getUserData() {
        var queryparam = this.route.queryParams;
        this.resetCode = queryparam ? queryparam['value']['url'] : null;
        this.code = queryparam['value']['code'] || "";
        this.userCredential = queryparam['value']['user'] || "";
        [this.user, this.domain] = this.userCredential.split('@');
        if (this.resetCode != null) {
            this.userName = this.resetCode.user;
            this.httpService.get(this.apiURL + 'auth/GetUserNameByURL', { url: this.resetCode }, false).subscribe(res => {
                if (res) {
                    let data = res as UserSetting;
                    this.userName = data.UserName;
                    this.passCode = data.PasswordCode;
                    this.loginForm = this.createForm(data.UserName, data.PasswordCode);
                    this.spinner.hide();
                }
            });
        }
        else {
            this.spinner.hide();
            this.loginForm = this.createForm('', '')
        }
    }

    onSubmit() {
        this.submitted = true;
        let validateForm = this.validate();
        if (!validateForm) {
            return;
        }
        else {
            var userToken = this.authService.getDecodedAccessToken(this.authHelper.GetAuthorizationTokenValue());
            const username = userToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
            const domainname=username.split("@")[1].toString();

            const params = {
                token: this.authHelper.GetAuthorizationTokenValue(),
                domain: domainname,
                userName: username,
                password: this.loginForm.getRawValue().password,
            } as any;


            this.httpService.postWithHeaderResetpassword(this.apiURL + 'auth/ResetPassword', params).subscribe(response => {
                var result = response as ResponseResult;
                if (result) {
                    this.showValidation = true;
                    this.helper.showNotification("Password reseted successfully!!!...")
                    this.router.navigate(['/authentication/signin/']);
                }
                else {
                    this.showValidation = false;
                }
            }, error => {
                if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
                    this.showValidation = false;
                    if (this.loginForm) {
                        this.loginForm.controls['code'].setErrors({ 'incorrect': true });
                        this.loginForm.controls['name'].setErrors({ 'incorrect': true });
                    }
                    return false;
                }
                this.showValidation = false;
            });
        }
    }

    onSkip() {
        let getStatusId = localStorage.getItem("StatusId");
        var StatusId = parseInt(getStatusId, 10);
        let id = localStorage.getItem("EncryptId");
        // let getPersonId = localStorage.getItem("PersonId");
        // var PersonId = parseInt(getPersonId, 10);
        if (StatusId > 2) {
            return `/patient-dashboard/${id}`
        } else {
            return `/patients/patient/edit/${id}`
        }
    }
}
